import Transform from "@ember-data/serializer/transform";
import CompoundSurveyFrequency from "compound-survey/models/compound-survey-frequency";
export default class CompoundSurveyFrequenciesTransform extends Transform {
  deserialize(serialized) {
    return serialized.map(item => new CompoundSurveyFrequency({
      ...item,
      enabled: true
    }));
  }
  serialize(deserialized) {
    return deserialized.map(freq => freq.serialize());
  }
}